var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeHeader'),(_vm.showGallery)?_c('gallery-highlight'):_vm._e(),_c('shop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }